exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quick-search-results {\n    background: #fff;\n    max-height: calc(100vh - 100px);\n    overflow-y: scroll;\n}\nol.ais-Hits-list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n.ais-SearchBox-submit {\n    background: transparent;\n    border: none;\n    padding: 16px 15px 14px;\n}\n.ais-SearchBox-submit svg {\n    width: 12px;\n    fill: #b5b6b6;\n    height: auto;\n}\n.ais-SearchBox-reset {\n    display: none;\n}\n", ""]);

// exports
